<template>
  <div class="otherAgain">
    <label for="">
      <span>代办时间:</span>
      <date-time :birthDay="otherList.getGoodsDate" :type="type" />
    </label>
    <label for="">
      <span>联系人姓名:</span>
      <input type="text" placeholder="请输入联系人姓名" v-model="otherList.name">
    </label>
    <label for="">
      <span>联系人电话:</span>
      <input type="text" placeholder="请输入联系人电话" v-model="otherList.mobile">
    </label>
    <!--地图-->
    <div id="allmap"  class="allmap"></div>
    <label for="">
      <span>服务内容:</span>
      <textarea placeholder="请输入服务内容" v-model="otherList.serviceContent"></textarea>
    </label>
    <label for="">
      <span>备注信息:</span>
      <textarea placeholder="请输入备注信息" v-model="otherList.remark"></textarea>
    </label>
    <p class="notice">注：不输入表示无要求</p>
    <label for="">
      <span>收货地址:</span>
      <input type="text" placeholder="小区名、大厦名、街道门牌号" @keyup.enter="getAddress" @blur="getAddress" v-model="otherList.sendAddress">
    </label>
    <label for="">
      <span>详细地址:</span>
      <input type="text" placeholder="楼层、门牌号" v-model="otherList.sendAddressDetail">
    </label>
    <button @click="next">下一步</button>
  </div>
</template>

<script>
import DateTime from '../../../components/Time'
import {mobiles} from '../../../utils/phone'
import {init} from '../../../utils/map'
import {reqOtherOrderDetail, reqOrderOther} from '../../../api'
export default {
  data() {
    return {
      otherList: {},

      type: 'datetime',
    }
  },
  created() {
    const {id} = this.$route.query
    reqOtherOrderDetail(id).then(res => {
      console.log(res)
      if(res.code === 200) {
        this.otherList = Object.assign(res.data.bussData, {sendAddressDetail: ''})
        init(res.data.bussData.sendAddress, 'allmap')
      }
    })
  },
  mounted() {
    init('深圳', 'allmap')
  },
  methods: {
    // 获取时间
    times (time) {
      this.info.getGoodsDate = time
    },
    // 根据地址名称更换地图
    getAddress (e) {
      let type = e.target.parentNode.nextElementSibling.nextElementSibling.id
      init(this.info.sendAddress, type)
    },
    next () {
      const {getGoodsDate, name, mobile, serviceContent, sendAddress, sendAddressDetail} = this.otherList
      if(!getGoodsDate) {
        this.$message({
          message: '代办时间不能为空',
          type:'error'
        })
      } else if(!name) {
        this.$message({
          message: '联系人姓名不能为空',
          type:'error'
        })
      } else if(!mobile) {
        this.$message({
          message: '联系人电话不能为空',
          type:'error'
        })
      } else if(!mobiles(mobile)) {
        this.$message({
          message: '联系人电话不正确',
          type:'error'
        })
      } else if(!serviceContent) {
        this.$message({
          message: '服务内容不能为空',
          type:'error'
        })
      } else if(!sendAddress) {
        this.$message({
          message: '收货地址不能为空',
          type:'error'
        })
      }else{
        this.$store.dispatch('getOtherInfo', this.otherList)
        reqOrderOther(Object.assign(this.otherList, {origin:1})).then(res => {
          if(res.code === 200) {
            this.$message({
              message: '提交成功',
              type: 'success'
            })
            this.$router.push({name: 'OtherOrder'})
          }
        })

      }
    }
  },
  components: {
    DateTime
  }
}
</script>

<style scoped lang="less" type="text/less">
  .otherAgain{
    padding-top:60px;
    label{
      display: flex;
      margin-bottom: 20px;
      &:last-of-type{
        margin-bottom: 0;
      }
      span{
        display: block;
        width: 80px;
        text-align: right;
        line-height: 40px;
        margin-right:12px;
      }
      input{
        width: 340px;
        height: 40px;
        text-indent: 13px;
        box-sizing: border-box;
        border:1px solid #e1e1e1;
        border-radius: 4px;
        &::-webkit-input-placeholder{
          color:#c0c4cc;
        }
      }
      textarea{
        width: 340px;
        height: 100px;
        resize: none;
        box-sizing: border-box;
        text-indent: 13px;
        border:1px solid #e1e1e1;
        border-radius: 4px;
        &::-webkit-input-placeholder{
          color:#c0c4cc;
        }
      }
    }
    .notice{
      margin-top:11px;
      margin-bottom: 40px;
      color:#999;
      text-indent: 102px;
    }
    button{
      width: 332px;
      height: 48px;
      margin:48px 0 0 53px;
      border:none;
      border-radius: 24px;
      background: #61aee6;
      color:#fff;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
    }
    .allmap{
      width: 511px;
      height: 260px;
      margin-top:20px;
      margin-bottom: 20px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/OtherAgain.vue